__turbopack_context__.v({
  "bannerRow": "mhnpFG_bannerRow",
  "content": "mhnpFG_content",
  "footerSettingsIconWrap": "mhnpFG_footerSettingsIconWrap",
  "footerSettingsLink": "mhnpFG_footerSettingsLink",
  "footerSettingsLinkActive": "mhnpFG_footerSettingsLinkActive",
  "footerUtilities": "mhnpFG_footerUtilities",
  "shell": "mhnpFG_shell",
});
